module.exports = __webpack_public_path__ + "img/b003.b59f5aaa.jpg";